// extracted by mini-css-extract-plugin
export default {"button":"Button__button--FL8jv","mini":"Button__mini--uUFKX"};